import { handle } from 'redux-pack';
import {
  FETCH_TARJETA,
  FETCH_TARJETA_BY_ID,
  FETCH_TARJETA_BY_ID_GRAFICA,
  FETCH_GRAFICA_COMPLETA,
  FETCH_GRAFICAS_COMPLETAS,
  LIMPIAR_ESTADO_TARJETA,
  UPDATE_TARJETA_REQUEST,
  UPDATE_TARJETA_SUCCESS,
  UPDATE_TARJETA_ERROR,
  CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS,
  LOGOUT
} from '../actions/types';
import { handleAction } from '../utils/handleAction';

const initialState = {
  tarjetas: [],
  tarjeta: null,
  graficasCompletas: [],
  isLoading: false,
  error: '',
  isUpdating: false,
  updateError: null
};

const TarjetaReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TARJETA:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          tarjetas: payload.data.data,
          total: payload.data.total
        }),
      });
    case FETCH_TARJETA_BY_ID:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          tarjeta: payload.data.data, // Extraer data de la respuesta de Axios
        }),
      });
    case FETCH_TARJETA_BY_ID_GRAFICA:
      return handle(state, action, {
        start: (prevState) => ({ ...prevState, isLoading: false }),
        finish: (prevState) => ({ ...prevState, isLoading: false }),
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          tarjeta: payload.data.data, // Extraer data de la respuesta de Axios
        }),
      });
    case FETCH_GRAFICA_COMPLETA:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          graficaCompleta: payload.data.data,
        }),
      });
    case FETCH_GRAFICAS_COMPLETAS:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload.message }),
        success: (prevState) => ({
          ...prevState,
          graficasCompletas: payload.data.data || payload.data,
        }),
      });
    case UPDATE_TARJETA_REQUEST:
      return {
        ...state,
        isUpdating: true,
        updateError: null
      };
    case UPDATE_TARJETA_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updateError: null,
        tarjeta: payload,
        tarjetas: state.tarjetas.map(tarjeta => 
          tarjeta._id === payload._id ? payload : tarjeta
        )
      };
    case UPDATE_TARJETA_ERROR:
      return {
        ...state,
        isUpdating: false,
        updateError: payload
      };
    case CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS:
      // Actualizar tarjeta en la lista cuando se cambia su estado
      if (action.payload.tipo === 'tarjeta') {
        const dispositivoActualizado = action.payload.dispositivo;
        const tarjetaId = dispositivoActualizado._id || dispositivoActualizado.id;

        return {
          ...state,
          // Solo actualizar la lista de tarjetas si existe y es un array
          tarjetas: Array.isArray(state.tarjetas) ? state.tarjetas.map(tarjeta =>
            tarjeta._id === tarjetaId
              ? { ...tarjeta, estatusDispositivo: dispositivoActualizado.estatusDispositivo }
              : tarjeta
          ) : state.tarjetas,
          // También actualizar la tarjeta individual si coincide con el ID
          tarjeta: state.tarjeta && (state.tarjeta._id === tarjetaId || state.tarjeta.id === tarjetaId)
            ? { ...state.tarjeta, estatusDispositivo: dispositivoActualizado.estatusDispositivo }
            : state.tarjeta
        };
      }
      return state;
    case LIMPIAR_ESTADO_TARJETA:
      return { ...initialState };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default TarjetaReducer;
